import React, { useState } from 'react';
import Expander from '@amzn/meridian/expander';
import Table from '@amzn/meridian/table';
import TableRow from '@amzn/meridian/table/table-row';
import TableCell from '@amzn/meridian/table/table-cell';
import Text from '@amzn/meridian/text';
import { useTranslation } from 'src/arb-wrapper';

interface ProductSetDisplayProps {
  productSets: Array<{ productSetId: string; productSetName?: string }>;
}

export const ProductSetDisplay: React.FC<ProductSetDisplayProps> = ({
  productSets,
}) => {
  const [expanderOpen, setExpanderOpen] = useState(false);
  const { t } = useTranslation();

  if (productSets.length === 0) {
    return null;
  }

  return (
    <Expander
      open={expanderOpen}
      title={t('product_sets_count', { count: productSets.length })}
      onChange={setExpanderOpen}
    >
      <Table headerRows={1} spacing="small">
        <TableRow>
          <TableCell width="60%">
            <Text type="b300">{t('product_set_name_header')}</Text>
          </TableCell>
          <TableCell width="40%">
            <Text type="b300">{t('product_set_id_header')}</Text>
          </TableCell>
        </TableRow>
        {productSets.map((productSet, idx) => (
          <TableRow key={idx}>
            <TableCell>
              <Text type="b200">
                {productSet.productSetName ?? t('not_available')}
              </Text>
            </TableCell>
            <TableCell>
              <Text type="b200">{productSet.productSetId}</Text>
            </TableCell>
          </TableRow>
        ))}
      </Table>
    </Expander>
  );
};
